export default __webpack_public_path__ + "static/Term_Dates-f47ece80495e5fec0849bcfb94f5255f.pdf";